import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { EnrichedBulletList } from '../interactions/EnrichedBulletList.jsx'

/**
 * LearningsCard — enriched bullets with source chip (mistake/experiment/colleague/studying).
 * catalog #5, prep-learnings. Reuses EnrichedBulletList (suffixType='source').
 */
export function LearningsCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []

  return (
    <CardFrame
      kind="prep"
      icon="⊛"
      iconClass="olive"
      title="Learnings"
      prompt="What did you pick up?"
      state={disabled ? 'locked' : items.some((i) => i.text) ? 'filled' : 'empty'}
      data-testid="prep-card-prep-learnings"
      className="prepcard"
    >
      <EnrichedBulletList
        items={items}
        onChange={onChange}
        suffixType="source"
        maxItems={15}
        maxChars={200}
        placeholder="Something you picked up…"
        disabled={disabled}
      />
    </CardFrame>
  )
}
